import { render, staticRenderFns } from "./NetdiskParse.vue?vue&type=template&id=0b980cce&scoped=true"
import script from "./NetdiskParse.vue?vue&type=script&lang=js"
export * from "./NetdiskParse.vue?vue&type=script&lang=js"
import style0 from "./NetdiskParse.vue?vue&type=style&index=0&id=0b980cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b980cce",
  null
  
)

export default component.exports